import React from 'react';
import { Listing } from '@/utils/platform-api/__generated__/graphql';

const ListingViewDescription: React.FC<{
  listing: Listing;
  size?: string;
  displayUnitView?: boolean;
}> = ({ listing, size = 'sm', displayUnitView }) => {
  if (!displayUnitView || !listing.unit_view) {
    return null;
  }

  return (
    <div className="flex w-full max-w-full items-center justify-start gap-2 self-stretch whitespace-nowrap">
      <div className="flex flex-row items-center gap-[0.25rem]">
        <span className={`ut-${size} text-center !font-normal text-gray-8`}>
          {listing.unit_view}
        </span>
      </div>
    </div>
  );
};

export default ListingViewDescription;
